import React from 'react';
import stringHelper from '../../../Helpers/stringHelper';
import OnOffField from './OnOffField';

export default class NumberWithTwoDecimalsCheckBox extends React.Component {
  static defaultProps = {
    value: null,
    className: 'w-100 form-control form-control-sm',
    fieldName: 'defaultFieldname',
    changeOfEditedMultipItem: () => {},
    editedItem: {},
    IsCheckBoxEnabled: false,
    onOffValue: '',
    onChange: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  renderNumberWithTwoDecimals() {
    const numberStyle = this.props.value === '' ? 'text' : 'number';
    return (
      <input
        type={numberStyle}
        step='0.01'
        className={this.props.className}
        placeholder='0.00'
        value={
          this.props.value === null || this.props.value === '' ? '' : stringHelper.removeTrailingZeros(this.props.value)
        }
        onChange={this.onChangeNumberWithTwoDecimals.bind(this)}
        id={`htmlidfor${this.props.fieldName}`}
        readOnly={false}
        autoComplete='off'
      />
    );
  }

  clickOnNumberWithTwoDecimalsCheckBox(onOffValue) {
    const newValue = !onOffValue;
    if (newValue === false) {
      this.props.changeOfEditedMultipItem([
        { fieldName: `${this.props.fieldName}Status`, newValue },
        { fieldName: this.props.fieldName, newValue: this.props.editedItem[`${this.props.fieldName}Orgin`] },
      ]);
    } else {
      this.props.onChange(`${this.props.fieldName}Status`, newValue);
    }
  }

  onChangeNumberWithTwoDecimals(e) {
    if (e.target.value === '') {
      this.props.onChange(this.props.fieldName, '');
      return;
    }
    this.props.onChange(this.props.fieldName, e.target.value);
  }

  render() {
    if (this.props.IsCheckBoxEnabled === false) {
      return this.renderNumberWithTwoDecimals();
    }

    if (this.props.editedItem[`${this.props.fieldName}Orgin`] === undefined) {
      this.props.editedItem[`${this.props.fieldName}Orgin`] = this.props.value;
      if (!this.props.editedItem[`${this.props.fieldName}Status`]) {
        this.props.editedItem[`${this.props.fieldName}Status`] =
          this.props.onOffValue === '' ? false : this.props.onOffValue;
      }
    }
    const onOffValue = this.props.editedItem[`${this.props.fieldName}Status`];
    return (
      <div className='inputCheckBoxCombo'>
        <div className='figmaOnOffButtonBox'>
          <OnOffField
            value={onOffValue}
            onChange={() => this.clickOnNumberWithTwoDecimalsCheckBox(onOffValue)}
          />
        </div>
        {onOffValue ? this.renderNumberWithTwoDecimals() : <div className='inputFigma' />}
      </div>
    );
  }
}
